/* SILQA-PRESS 2026-07-31 河瀬さん指摘「カート内の商品追加・削除がワンテンポ遅い。
   無反応かと思って追加でタップし誤操作になる。タップした瞬間に反映される速度にできないか」への対策。

   実測(スマホ4G・低速CPU)では処理自体は速く、削除は行が消えるまで13ms、追加はドロワーが開くまで92msだった。
   遅く感じる原因は「指が触れた瞬間にボタン自体が何も変わらない」こと。
   CSSの :active は端末やブラウザによって発火が遅れたりスクロール判定に吸われるため、
   pointerdown（clickより前・指が触れた瞬間）で確実に押下状態のクラスを付ける。
   見た目だけの処理で、カートの通信・状態管理には一切関与しない。 */
(function () {
  if (window.__silqaPressInit) return;
  window.__silqaPressInit = true;
  var SEL = '.product-form__submit,#CartDrawer cart-remove-button,#CartDrawer .quantity__button,.silqa-cardadd,.silqa-ladder__add,.silqa-cartset__add,.silqa-set__add,[data-silqa-quick-add]';
  var cur = null;
  var off = function () { if (cur) { cur.classList.remove('silqa-pressed'); cur = null; } };
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest ? e.target.closest(SEL) : null;
    if (!t || t.disabled) return;
    off();
    cur = t;
    t.classList.add('silqa-pressed');
  }, { capture: true, passive: true });
  ['pointerup', 'pointercancel', 'pointerleave', 'touchend', 'touchcancel'].forEach(function (ev) {
    document.addEventListener(ev, off, { capture: true, passive: true });
  });
  document.addEventListener('scroll', off, { capture: true, passive: true });
})();
/* SILQA-CART-ADD 2026-07-31: HTMLに毎回25KB直書きされていたものを外部ファイル化（キャッシュ対象・全ページのHTMLが軽くなる）。
   読み込み順は theme.liquid で defer 指定し、Dawnのカート系JSより前に置くこと（window.fetchの差し替えが先に効く必要があるため）。 */

(function () {
  if (window.silqaCartAdd) return;

  /*
    SILQA 2026-07-30 河瀬さん指示・不具合修正（通信の入り口での補完）:
    Shopifyはカート操作(add/change/update)が成功(200)しても、画面部品(sections)を
    返さないことが時々ある（実測で確認）。Dawn標準の処理は部品が無いと
    例外で止まり、「空カートの見た目だけ適用されて中身が白い」等の崩れを起こす。
    ここでカート操作の応答を検査し、部品が欠けていたら GET /?sections=... で
    取り直してから各処理に渡す。これでDawn・共通関数どちらの経路も部品必達になる。
  */
  var NATIVE_FETCH = window.fetch;

  /*
    SILQA 2026-07-30 河瀬さん指示・不具合修正（部品の取り直し先を変更）:
    以前は GET /?sections=... で取り直していたが、トップページ経由の描画は
    キャッシュ/反映遅延により「追加前の空カート」で作られた部品が返ることがあり、
    ・カートアイコンに数字が付かない
    ・空カートの骨組み（おすすめ・押せない購入ボタン）と商品行が混在する
    という報告症状そのものを引き起こしていた。
    カート専用の口 POST /cart/update.js（空更新）は必ずその時点の本物のカートで
    部品を描画するため、こちらに統一する。
  */
  /*
    SILQA 2026-07-31 実機ログによる追加改良: 河瀬さんの実機(Brave)で、change/update の応答から
    sections が「毎回」欠落する状態を観測（addは有り）。POST /cart/update.js の空更新でも
    部品が返らないため、その場合は Section Rendering API の GET でも取りに行く。
    GETはCDNの古いカートを掴む既知の罠があるため、毎回ユニークなクエリを付けてキャッシュを貫通させ、
    さらに描画後の行数照合（150ms同期）が食い違いを検知したら描き直す二重の保険付き。
  */
  function fetchSectionsViaGet() {
    return NATIVE_FETCH('/?sections=cart-drawer,cart-icon-bubble&_silqa=' + Date.now())
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || j['cart-drawer'] == null) throw new Error('sections missing');
        return { sections: j };
      });
  }
  function postUpdateForSections() {
    return NATIVE_FETCH('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j.sections || j.sections['cart-drawer'] == null) {
          // この端末ではPOSTに部品が付かないと学習→次回からGETを先に使う（毎回の無駄な1往復を削る）
          learnNoSections(true);
          throw new Error('sections missing');
        }
        return { sections: j.sections };
      });
  }
  // 「この端末はPOSTに部品が付かない」の学習は端末（タブ）単位で記憶し、
  // ページを移動しても初回から速い経路（GET先行）を使う
  var updNoSections = false;
  try { updNoSections = sessionStorage.getItem('silqaNoSec') === '1'; } catch (e) {}
  function learnNoSections(v) {
    updNoSections = v;
    try { if (v) sessionStorage.setItem('silqaNoSec', '1'); else sessionStorage.removeItem('silqaNoSec'); } catch (e) {}
  }
  function fetchFreshSectionsOnce() {
    if (updNoSections) {
      return fetchSectionsViaGet().catch(function () { learnNoSections(false); return postUpdateForSections(); });
    }
    return postUpdateForSections().catch(function () { return fetchSectionsViaGet(); });
  }
  // SILQA 2026-07-31 河瀬さん指示・不具合修正（真っ白/強制再読込の根因）:
  // 復旧要求が重なると /cart/update.js を短時間に何度も叩き、Shopifyの回数制限(429)を
  // 自分で誘発して全復旧が失敗していた。取り直しは進行中の1本をみんなで共有し、
  // 失敗時は間隔を空けて計3回まで粘る。これで一時的な429でも復旧が生き残る。
  var freshWait = null;
  function fetchFreshSections() {
    if (freshWait) return freshWait;
    freshWait = new Promise(function (resolve, reject) {
      var delays = [0, 2200, 4400];
      var i = 0;
      var go = function () {
        fetchFreshSectionsOnce().then(
          function (d) { freshWait = null; resolve(d); },
          function (e) {
            i += 1;
            if (i < delays.length) { setTimeout(go, delays[i]); }
            else { freshWait = null; reject(e); }
          }
        );
      };
      go();
    });
    return freshWait;
  }

  (function () {
    /*
      ドロワーの部品(cart-drawer)を要求している操作だけを対象にする。
      カートページの数量変更などは別の部品(cart-items等)を使うため対象外
      （余計な補完リクエストや、カートページでの不要な再読込を防ぐ）。
    */
    function wantsSections(init) {
      if (!init || !init.body) return false;
      var b = init.body;
      try {
        if (typeof b === 'string') return b.indexOf('cart-drawer') > -1;
        if (typeof FormData !== 'undefined' && b instanceof FormData) return String(b.get('sections') || '').indexOf('cart-drawer') > -1;
        if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return String(b.get('sections') || '').indexOf('cart-drawer') > -1;
      } catch (e) {}
      return false;
    }
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      // Dawn標準は routes.cart_add_url = '/cart/add'（.jsなし）を使うため、両形式にマッチさせる
      if (!/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) || !wantsSections(init)) {
        return NATIVE_FETCH.apply(this, arguments);
      }
      return NATIVE_FETCH.apply(this, arguments).then(function (res) {
        if (!res.ok) {
          // SILQA 2026-07-31: 422「line パラメータは無効です」等 = 画面の行と実カートのズレが原因。
          // 部品を取り直して静かに実カートへ同期する（放置すると以後その行が消せなくなる）
          if (res.status === 422 || res.status === 400 || res.status === 404) scheduleQuietRepair();
          return res;
        }
        return res.clone().json().then(function (j) {
          /*
            SILQA 2026-07-30 河瀬さん指示・不具合修正（真っ白ドロワーの保険）:
            空カート表示の出し分けは cart-drawer / cart-drawer-items の is-empty クラスに
            依存しており、Dawn側の付け替えが例外等で飛ぶと「クラスと中身の食い違い」で
            白画面や混在画面になる。応答のitem_countを正として、描画処理の後に必ず同期する。
            （部品を要求した操作＝画面を描き替える操作のときのみ。数量はaddの応答に
            item_countが無いため、追加成功=空ではない、として扱う）
          */
          var emptyNow = typeof j.item_count === 'number' ? j.item_count === 0 : false;
          setTimeout(function () {
            if (document.querySelector('cart-items')) return; // カートページは対象外
            var cd = document.querySelector('cart-drawer');
            var cdi = document.querySelector('cart-drawer-items');
            if (cd) cd.classList.toggle('is-empty', emptyNow);
            if (cdi) cdi.classList.toggle('is-empty', emptyNow);
            /*
              クラスと中身の食い違い検知（最終保険）: 「空のはずなのに空カート表示が無い」
              「商品があるはずなのに商品行が無い」場合は、部品を取り直して静かに描き直す。
              （補完もDawnの描画も失敗した極端なケースで、古い商品行が残るのを防ぐ）
            */
            var hasEmptyBlock = !!document.querySelector('#CartDrawer .drawer__inner-empty');
            var hasRows = !!document.querySelector('#CartDrawer .cart-item');
            if (emptyNow && !hasEmptyBlock) {
              // SILQA 2026-07-31: 真っ白の即時応急処置。ページ内に常備した空カート表示の
              // 雛形(template)を通信なしで差し込む（後段の取り直しが本物に描き直す）
              applyEmptyTemplate();
              hasEmptyBlock = !!document.querySelector('#CartDrawer .drawer__inner-empty');
            }
            // SILQA 2026-07-31: 空/非空だけでなく「行数の食い違い」も検知して同期する。
            // 古い行が残ったまま操作すると 422（行番号ズレ）や誤操作の元になるため
            var wantRows = (typeof j.item_count === 'number' && j.items && j.items.length != null) ? j.items.length : null;
            var rowsNow = document.querySelectorAll('#CartDrawer .cart-item').length;
            var rowsMismatch = wantRows != null && rowsNow !== wantRows;
            if ((emptyNow && !hasEmptyBlock) || (!emptyNow && !hasRows) || rowsMismatch) scheduleQuietRepair();
          }, 150);
          var missing = !j.sections
            || j.sections['cart-drawer'] == null
            || j.sections['cart-icon-bubble'] == null;
          if (!missing) return res;
          return fetchFreshSections()
            .then(function (fresh) {
              var s = fresh.sections;
              j.sections = j.sections || {};
              if (j.sections['cart-drawer'] == null && s['cart-drawer'] != null) j.sections['cart-drawer'] = s['cart-drawer'];
              if (j.sections['cart-icon-bubble'] == null && s['cart-icon-bubble'] != null) j.sections['cart-icon-bubble'] = s['cart-icon-bubble'];
              return new Response(JSON.stringify(j), { status: res.status, statusText: res.statusText, headers: { 'Content-Type': 'application/json' } });
            })
            .catch(function () { return res; });
        }).catch(function () { return res; });
      });
    };
  })();

  /*
    SILQA 2026-07-30 河瀬さん指示・不具合修正:
    旧showErrorはボタンの親要素にメッセージを差し込んでいたが、おすすめ枠
    (.silqa-ladder等)はflexレイアウトのため、差し込まれた文が同じ行の中で
    幅を奪い、商品名が1文字ずつ縦に積まれる崩れが起きていた。
    メッセージは枠（行コンテナ）の外側・全幅で表示する。
  */
  function showError(btn, msg) {
    if (!btn) return;
    var row = btn.closest
      ? btn.closest('.silqa-ladder, [data-setbox-row], .silqa-cartset, .silqa-related__card, .silqa-relcard')
      : null;
    var anchor = row || btn.parentElement || btn;
    var scope = anchor.parentElement || anchor;
    var old = scope.querySelector('[data-silqa-add-error]');
    if (old) old.remove();
    var el = document.createElement('span');
    el.setAttribute('data-silqa-add-error', '');
    el.setAttribute('role', 'alert');
    el.style.cssText = 'display:block;width:100%;flex:0 0 100%;margin-top:6px;font-size:1.15rem;line-height:1.5;color:#c0392b;';
    el.textContent = msg;
    if (row && row.parentElement) {
      row.insertAdjacentElement('afterend', el);
    } else {
      anchor.appendChild(el);
    }
    setTimeout(function () { if (el.parentNode) el.remove(); }, 6000);
  }

  var silqaPendingCartNotice = '';
  var silqaCartNoticeTimer = null;
  function silqaPaintCartNotice() {
    if (!silqaPendingCartNotice) return;
    var el = document.getElementById('CartDrawer-CartErrors');
    if (!el) return;
    el.setAttribute('data-silqa-cart-notice', '');
    el.style.cssText = 'display:block;margin:12px 0;padding:10px 12px;border:1px solid #d8a641;border-radius:8px;background:#fff9e8;color:#6b4b00;font-size:1.2rem;line-height:1.5;';
    el.textContent = silqaPendingCartNotice;
  }
  function silqaShowCartNotice(msg) {
    silqaPendingCartNotice = msg;
    silqaPaintCartNotice();
    clearTimeout(silqaCartNoticeTimer);
    silqaCartNoticeTimer = setTimeout(function () {
      var oldMsg = silqaPendingCartNotice;
      silqaPendingCartNotice = '';
      var el = document.getElementById('CartDrawer-CartErrors');
      if (el && el.textContent === oldMsg) {
        el.textContent = '';
        el.removeAttribute('data-silqa-cart-notice');
        el.removeAttribute('style');
      }
      // SILQA 2026-08-24: 10000→8000。
      //   この案内は renderVerifiedCart() でカートを描き直したあとに出るので、
      //   タップから表示までに実測2.1秒かかる。10秒表示だと消えるのが12.1秒後になり、
      //   引継ぎの合格条件「11秒後までに消える」を満たせなかった。
      //   8秒表示なら 2.1秒に出て10.1秒に消え、「2秒後と7秒後に見える」も保てる。
    }, 8000);
  }

  /*
    SILQA 2026-07-27 河瀬さん指示・不具合修正:
    以前は Shopify標準の renderContents を先に試し、失敗したら自力で差し替える
    「2経路」構成にしていた。そのため商品によってどちらが走るかが変わり、
      - フードでは正常、ラージでは表示が崩れる
      - 代替経路ではカートアイコンの数字を更新していなかったため、
        右上のカート数が増えない
    という商品差が出ていた。

    経路を1つに統一し、常に同じ手順で描画する。
      (1) カートアイコン（cart-icon-bubble）を更新
      (2) ドロワー内側（#CartDrawer）を差し替え
      (3) 空カート表示の痕跡（is-empty / drawer__inner-empty）を除去
      (4) ドロワーを開く
  */
  function sectionInnerHTML(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  // SILQA 2026-07-31: 真っ白ドロワーの最終保険。cart-drawer.liquid が常備している
  // 空カート表示の雛形(<template data-silqa-empty-drawer>)を通信なしで差し込む。
  // 差し替えるのは .drawer__inner の中身だけ＝オーバーレイのタップ閉じは生きたまま。
  function applyEmptyTemplate() {
    var tpl = document.querySelector('template[data-silqa-empty-drawer]');
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    var cd = document.querySelector('cart-drawer');
    if (!tpl || !inner || !cd) return false;
    inner.innerHTML = tpl.innerHTML;
    // SILQA 2026-08-22 河瀬さん報告の不具合修正「削除に失敗しても何も出ない」:
    //   この雛形には #CartDrawer-CartErrors が入っていないため、差し替えた瞬間に
    //   エラーの表示先が消え、そのあと削除が失敗しても文言を出せなくなっていた。
    //   （最後の1行を消したときに必ずこの状態になる）
    //   無ければ作って残す。中身は空なので見た目は変わらない。
    if (!inner.querySelector('#CartDrawer-CartErrors')) {
      var errBox = document.createElement('div');
      errBox.id = 'CartDrawer-CartErrors';
      errBox.setAttribute('role', 'alert');
      inner.appendChild(errBox);
    }
    cd.classList.add('is-empty');
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) bubble.remove();
    // 差し替えで消えた「失敗の一言」を書き戻す（2026-08-22）
    silqaPaintCartNotice();
    silqaPaintFailNote();
    return true;
  }

  // open=false のときは差し替えのみ（bfcache復元時の静かな同期用）
  function renderDrawer(data, open) {
    // カートページを開いている場合はドロワーではなく本文の更新が必要＝再読込が最も確実。
    // sectionsの有無より先に判定する（部品が欠けていてもカートページなら再読込で必ず復旧できるため）
    if (document.querySelector('cart-items')) {
      window.location.reload();
      return true;
    }

    var cd = document.querySelector('cart-drawer');
    if (!data || !data.sections || !cd) return false;

    // (1) ドロワー内側を先に差し替える（先にアイコンだけ更新して中身の差し替えに失敗すると、
    //     アイコンと中身が食い違う中途半端な状態になるため、順序を「中身→アイコン」にする）
    var inner = document.querySelector('#CartDrawer');
    var freshInner = data.sections['cart-drawer'] ? sectionInnerHTML(data.sections['cart-drawer'], '#CartDrawer') : null;
    if (!inner || freshInner === null) return false;
    inner.innerHTML = freshInner;

    // innerHTML差し替えで暗幕(オーバーレイ)の「タップで閉じる」イベントが消えるため張り直す
    var ov = inner.querySelector('#CartDrawer-Overlay');
    if (ov && typeof cd.close === 'function') ov.addEventListener('click', cd.close.bind(cd));

    // (2) カートアイコンの数字。ここを忘れると「追加したのに数が増えない」になる
    if (data.sections['cart-icon-bubble']) {
      var bubbleHost = document.getElementById('cart-icon-bubble');
      var bubbleHTML = sectionInnerHTML(data.sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleHost && bubbleHTML !== null) bubbleHost.innerHTML = bubbleHTML;
    }

    // (3) 空カート表示の痕跡を除去（空になった時は逆に is-empty を必ず付ける。
    //     SILQA 2026-07-31: key方式の削除でここを通るようになったため両方向を同期）
    var emptyNow = /drawer__inner-empty/.test(freshInner) && !/cart-item(\s|")/.test(freshInner);
    if (!emptyNow) {
      cd.classList.remove('is-empty');
      var leftoverEmpty = inner.querySelector('.drawer__inner-empty');
      if (leftoverEmpty && inner.querySelector('.cart-item')) leftoverEmpty.remove();
    } else {
      cd.classList.add('is-empty');
    }

    // (4) 開く
    if (open !== false) {
      if (typeof cd.open === 'function') {
        cd.open();
      } else {
        cd.classList.add('animate', 'active');
      }
    }
    // 描き直しで消えた「失敗の一言」を書き戻す（2026-08-22）
    silqaPaintCartNotice();
    silqaPaintFailNote();
    // 商品ページ側のセット価格も、差し替え後の実カート割引に同期させる。
    document.dispatchEvent(new CustomEvent('silqa:cart-rendered'));
    return true;
  }

  // ドロワー部品だけを取り直す（追加応答にsectionsが無かった時の復旧路）
  // ※必ず /cart/update.js の空更新経由（fetchFreshSections）。古いカートで描画された部品を掴まない
  var fetchSections = fetchFreshSections;

  // 描画を必ず成功させる: 応答sections → GET再取得 → 最終手段は再読込+自動再オープン
  function renderOrRecover(data) {
    if (renderDrawer(data)) return Promise.resolve(true);
    return fetchSections()
      .then(function (d2) { return renderDrawer(d2); })
      .catch(function () { return false; })
      .then(function (ok) {
        if (ok) return true;
        try { sessionStorage.setItem('silqaReopenDrawer', '1'); } catch (e) {}
        window.location.reload();
        return true;
      });
  }

  /*
    SILQA 2026-07-27: 外部スクリプト（assets/silqa-pdp-widgets.js の交換用カバー処理）からも
    同じドロワー描画を使えるように公開する。戻り値 true = 描画できた。
  */
  window.silqaCartRenderDrawer = function (data) {
    return renderDrawer(data);
  };

  function postItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) {
        var err = new Error('HTTP ' + r.status);
        err.silqaStatus = r.status;
        err.silqaNonRetryable = r.status === 422;
        var retryAfter = parseFloat(r.headers && r.headers.get ? (r.headers.get('Retry-After') || '0') : '0');
        err.silqaRetryAfterMs = retryAfter > 0 ? retryAfter * 1000 : 0;
        return r.clone().json().catch(function () { return null; }).then(function (payload) {
          if (payload) err.silqaMessage = payload.description || payload.message || '';
          throw err;
        });
      }
      return r.json();
    });
  }

  // 追加応答が失われても、Shopify側では追加済みの場合がある。闇雲に再POSTすると
  // 数量が二重になるため、追加前後の /cart.js を照合してから再試行する。
  function drawerVariantCounts() {
    var counts = {};
    var inputs = document.querySelectorAll('#CartDrawer input[data-quantity-variant-id]');
    Array.prototype.forEach.call(inputs, function (input) {
      var id = String(input.getAttribute('data-quantity-variant-id') || '');
      if (!id || Object.prototype.hasOwnProperty.call(counts, id)) return;
      var q = parseInt(input.getAttribute('data-cart-quantity') || input.value || '0', 10);
      counts[id] = isNaN(q) ? 0 : q;
    });
    return counts;
  }
  function fetchCartCounts() {
    return NATIVE_FETCH('/cart.js?_silqa=' + Date.now(), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart HTTP ' + r.status);
      return r.json();
    }).then(function (cart) {
      var counts = {};
      Array.prototype.forEach.call((cart && cart.items) || [], function (item) {
        var id = String(item.variant_id || item.id || '');
        counts[id] = (counts[id] || 0) + (parseInt(item.quantity, 10) || 0);
      });
      return counts;
    });
  }
  function requestedVariantCounts(items) {
    var counts = {};
    Array.prototype.forEach.call(items || [], function (item) {
      var id = String(item.id || '');
      if (!id) return;
      counts[id] = (counts[id] || 0) + (parseInt(item.quantity, 10) || 1);
    });
    return counts;
  }
  function requestWasApplied(before, after, requested) {
    if (!before || !after) return false;
    for (var id in requested) {
      if (!Object.prototype.hasOwnProperty.call(requested, id)) continue;
      if ((after[id] || 0) < (before[id] || 0) + requested[id]) return false;
    }
    return true;
  }
  function requestAppliedQuantity(before, after, requested) {
    if (!before || !after) return 0;
    var applied = 0;
    for (var id in requested) {
      if (!Object.prototype.hasOwnProperty.call(requested, id)) continue;
      var increased = Math.max(0, (after[id] || 0) - (before[id] || 0));
      applied += Math.min(increased, requested[id]);
    }
    return applied;
  }
  function waitFor(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }
  function retryDelay(error, attempt) {
    var fromServer = error && error.silqaRetryAfterMs ? error.silqaRetryAfterMs : 0;
    if (error && error.silqaStatus === 429) return Math.max(fromServer, attempt === 1 ? 5000 : 10000);
    return attempt === 1 ? 1400 : 3000;
  }
  function renderVerifiedCart() {
    return fetchSectionsViaGet()
      .then(function (data) { return renderDrawer(data); })
      .then(function (ok) {
        if (ok) return true;
        throw new Error('verified cart render failed');
      })
      .catch(function () {
        try { sessionStorage.setItem('silqaReopenDrawer', '1'); } catch (e) {}
        window.location.reload();
        return true;
      });
  }

  function post(id, props) {
    var item = { id: id, quantity: 1 };
    if (props) item.properties = props;
    return postItems([item]);
  }

  /*
    SILQA 2026-07-31 河瀬さん指示（体感の即時化）: タップした瞬間にドロワーを開き
    「カートに追加しています…」の帯を出す。サーバーの正解が届いたら本描画で自動的に消える。
    サーバー往復(0.7〜1秒)を待たずに画面が反応するため、体感は0.1秒台になる。
  */
  var optCssDone = false;
  /*
    SILQA 2026-07-31 河瀬さん指摘の追修正: 空カートからの追加時、開いた瞬間に
    「カートの中身が空です」が見えてから商品に変わる不自然な順番になっていた。
    空カートの時は「空です」表示を先に隠し、中央の読み込み表示→商品 の順にする。
    追加が失敗した時だけ空カート表示に戻す。
  */
  function optimisticAddStart() {
    var cd = document.querySelector('cart-drawer');
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!cd || !inner) return null;
    if (!optCssDone) {
      optCssDone = true;
      try {
        var st = document.createElement('style');
        st.textContent = '@keyframes silqaOptSpin{to{transform:rotate(360deg)}}';
        document.head.appendChild(st);
      } catch (e) {}
    }
    var old = inner.querySelector('[data-silqa-optimistic]');
    if (old) old.remove();
    var wasEmpty = cd.classList.contains('is-empty');
    var emptyBlock = null;
    var el = document.createElement('div');
    el.setAttribute('data-silqa-optimistic', '');
    if (wasEmpty) {
      cd.classList.remove('is-empty');
      emptyBlock = inner.querySelector('.drawer__inner-empty');
      if (emptyBlock) emptyBlock.style.display = 'none';
      el.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:56px 20px 40px;color:#1c1816;font-size:1.3rem;';
      el.innerHTML = '<span style="width:26px;height:26px;border:3px solid #d2bc81;border-top-color:transparent;border-radius:50%;display:inline-block;animation:silqaOptSpin .8s linear infinite"></span>カートに追加しています…';
      var header = inner.querySelector('.drawer__header');
      if (header && header.nextSibling) { inner.insertBefore(el, header.nextSibling); } else { inner.appendChild(el); }
    } else {
      el.style.cssText = 'position:absolute;top:0;left:0;right:0;z-index:9;display:flex;align-items:center;gap:8px;padding:10px 14px;background:#fdfaf3;border-bottom:1px solid #e6d5a1;font-size:1.25rem;color:#1c1816;';
      el.innerHTML = '<span style="width:14px;height:14px;border:2px solid #d2bc81;border-top-color:transparent;border-radius:50%;display:inline-block;animation:silqaOptSpin .8s linear infinite"></span>カートに追加しています…';
      inner.style.position = 'relative';
      inner.appendChild(el);
    }
    if (typeof cd.open === 'function') { cd.open(); } else { cd.classList.add('animate', 'active'); }
    var opt = {
      el: el,
      fail: function () {
        if (el.isConnected) el.remove();
        if (wasEmpty) {
          var cdNow = document.querySelector('cart-drawer');
          if (cdNow) cdNow.classList.add('is-empty');
          if (emptyBlock && emptyBlock.isConnected) emptyBlock.style.display = '';
        }
      }
    };
    // 万一の取り残し保険: 12秒経っても残っていたら失敗扱いで元に戻す
    setTimeout(function () { if (el.isConnected) opt.fail(); }, 12000);
    return opt;
  }

  // 追加前後の実カート照合付きで最大3回。429はShopifyの制限解除を待ってから再試行する。
  function addAndRender(items, btn) {
    var busyLabel = null;
    if (btn) {
      btn.setAttribute('disabled', '');
      // SILQA 2026-07-31: おすすめ/クイック系の小ボタンは「追加中…」で処理中を明示
      // （通信が遅い実機での"無反応に見える"対策。本体CTAのラベルは変えない）
      if (btn.matches && btn.matches('.silqa-ladder__add, .silqa-cartset__add, [data-silqa-quick-add]')) {
        busyLabel = btn.textContent;
        btn.textContent = '追加中…';
      }
    }
    var opt = optimisticAddStart();
    var displayedBefore = drawerVariantCounts();
    var requested = requestedVariantCounts(items);
    var done = function () {
      if (btn) {
        btn.removeAttribute('disabled');
        if (busyLabel != null) btn.textContent = busyLabel;
      }
    };
    // 成功時は本描画が読み込み表示ごと差し替えるので、明示的な後片付けは失敗時だけ行う
    var failVisual = function () { done(); if (opt) opt.fail(); };
    var succeed = function (d) { done(); return renderOrRecover(d); };
    return fetchCartCounts().catch(function () { return displayedBefore; }).then(function (before) {
      var attempt = 0;
      function run() {
        attempt += 1;
        return postItems(items).then(succeed).catch(function (error) {
          return fetchCartCounts().catch(function () { return null; }).then(function (after) {
            if (requestWasApplied(before, after, requested)) {
              done();
              return renderVerifiedCart();
            }
            var appliedQuantity = requestAppliedQuantity(before, after, requested);
            if (appliedQuantity > 0) {
              done();
              return renderVerifiedCart().then(function () {
                var msg = '在庫の都合により、ご希望数量のうち' + appliedQuantity + '点をカートに追加しました。カート内の数量をご確認ください。';
                silqaShowCartNotice(msg);
                return false;
              });
            }
            if (error && error.silqaNonRetryable) throw error;
            if (attempt >= 3) throw error;
            return waitFor(retryDelay(error, attempt)).then(run);
          });
        });
      }
      return run();
    }).catch(function (error) {
      failVisual();
      if (error && error.silqaStatus === 422) {
        silqaShowCartNotice('在庫数または購入上限を超えています。数量を減らして、もう一度お試しください。');
      } else {
        silqaShowCartNotice('追加できませんでした。通信が混み合っています。少し待ってからもう一度お試しください。');
      }
      return false;
    });
  }

  /*
    複数商品をまとめて追加する入口（PDPの「セットでカートに追加」用）。
    単品追加の window.silqaCartAdd と同じ成功/失敗処理を共有する。
  */
  window.silqaCartAddItems = function (items, btn) {
    if (!items || !items.length) return;
    return addAndRender(items, btn);
  };

  window.silqaCartAdd = function (id, btn, props) {
    if (!id) return;
    var item = { id: id, quantity: 1 };
    if (props) item.properties = props;
    return addAndRender([item], btn);
  };

  /*
    SILQA 2026-07-30 河瀬さん指示・不具合修正:
    「シュシュはカートに追加を押しても無反応。ページを更新すると入っている」

    原因: 追加処理を共通経路に流し込むクリック処理を silqa-set-box.liquid の中に置いていたが、
    セット割ボックスはシルク枕4商品にしか表示されない。そのためシュシュ・アイマスク・
    交換用カバーなどはShopify標準の処理のままで、
      - 追加自体はサーバー側で成功しているのにドロワーも右上のカート数も更新されない
      → 利用者からは「無反応」に見え、ページ更新で初めて反映される
    という状態だった。

    この処理はレイアウト（theme.liquid → cart-drawer）から読み込まれ全ページで動くため、
    ここに置くことで全商品・PC/スマホ共通で同じ挙動になる。
    セット割ボックスがあるページは silqa-set-box 側が担当するので二重追加しないよう見送る。
  */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('button.product-form__submit, button[name="add"]')
      : null;
    if (!btn || btn.hasAttribute('disabled')) return;

    // セット割ボックスのあるページ（シルク枕）は set-box 側が処理する
    if (document.querySelector('[data-silqa-setbox]')) return;

    // SILQA 2026-07-31 レビュー指摘対応: 交換用カバー同時購入(widget3)の数量が入っている場合は
    // widget3の送信横取りが「枕＋カバー」をまとめて投入する。ここで横取りするとカバーが黙って
    // 捨てられるため、widget3に任せて手を出さない
    var covQty = document.querySelector('[data-silqa-coveropt-qty]');
    if (covQty && parseInt(covQty.value, 10) > 0) return;

    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    var idEl = form.querySelector('[name="id"]');
    // バリエーション未選択（選択モーダルを開くボタン）は標準動作にまかせる
    if (!idEl || !idEl.value) return;

    /*
      SILQA 2026-07-30 河瀬さん指示・不具合修正: Dawnの数量入力欄は<form>の外にあり
      form属性で紐づくため、form.querySelectorでは見つからず常に1扱いだった。
      form.elements（form属性の紐づけも含む）→ 画面上の入力欄の順で探す。
      ※このコメントは {%- -%}（改行削除タグ）を使わないこと。直前の行と連結されて
        次の var 宣言がJSのコメントに飲み込まれる事故が実際に起きた（2026-07-30）。
    */
    var qtyEl = form.elements ? form.elements['quantity'] : null;
    if (!qtyEl) qtyEl = document.querySelector('.product-form__quantity [name="quantity"]') || form.querySelector('[name="quantity"]');
    var qty = qtyEl && parseInt(qtyEl.value, 10) > 0 ? parseInt(qtyEl.value, 10) : 1;

    var props = {};
    var ctrls = form.elements ? Array.prototype.slice.call(form.elements) : Array.prototype.slice.call(form.querySelectorAll('[name^="properties["]'));
    ctrls.forEach(function (p) {
      if (!p.name || p.name.indexOf('properties[') !== 0) return;
      if (p.type === 'checkbox' && !p.checked) return;
      var m = p.name.match(/^properties\[(.+)\]$/);
      if (m && p.value) props[m[1]] = p.value;
    });

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var item = { id: idEl.value, quantity: qty };
    if (Object.keys(props).length) item.properties = props;
    window.silqaCartAddItems([item], btn);
  }, true);

  /*
    SILQA 2026-07-31 河瀬さん指示・不具合修正:
    「ドロワーから商品を削除すると、まれに『lineパラメータは無効です』と表示され削除
    できなくなる／エラーなしでゴミ箱が無反応になることがある」

    原因: Dawn標準の削除・数量変更は「行番号(line)」でカートを指定する。画面の行が
    一度でも古くなる（部品欠落・429で描き直し失敗・処理中の二度押し）と、行番号が
    実カートとズレて 422 になり、以後その行は消せない。処理中は行全体が操作不能に
    なるため、通信が遅いと「ゴミ箱が無反応」に見える。

    対策: 行番号ではなく、行に焼き込んだ不変の識別子(item.key)で指定する方式に
    置き換える（ドロワー内のみ。カートページは従来どおり）。二度押しは処理中ガードで
    無視し、処理中は該当行を薄く表示。失敗時は部品を取り直して実カートに同期する。
  */
  var changeBusy = {};
  var changePending = {};
  var changeChain = Promise.resolve();
  function silqaFindRow(key) {
    var el = document.querySelector('#CartDrawer [data-silqa-key="' + key + '"]');
    return el && el.closest ? el.closest('.cart-item') : null;
  }
  /*
    SILQA 2026-07-31 実測による重要事実: この店ではセット割(Shopify Functions)が働くため、
    枕を削除すると連れ商品(カバー等)の割引が外れ、その行の識別子(key)が再生成されて変わる。
    そのため「クリック時に控えたkey」は、直前に別の変更が入ると古くなることがある。
    対策: 送信の直前に、画面の最新の行から同じ商品(variant)のkeyへ引き直す。
    それでも削除が空振りした場合（対象の行が画面に残っている）は、最新keyで1回だけやり直す。
  */
  function silqaCurrentKey(key, variantId) {
    if (document.querySelector('#CartDrawer [data-silqa-key="' + key + '"]')) return key;
    // SILQA 2026-07-31 レビュー指摘対応: 同じ商品(variant)の行が複数あるとき（例: 通常追加と
    // セット経由でプロパティ違いの2行）、先頭一致で引き直すと「別の行」を操作してしまう。
    // 引き直しは「その商品の行が画面に1行だけ」のときに限定する。曖昧なら元keyのまま送り、
    // サーバーの400応答側の再解決（実カート照会・1行のときのみ）に委ねる。
    if (variantId) {
      var hosts = document.querySelectorAll('#CartDrawer cart-remove-button[data-silqa-key]');
      var hit = null, hitCount = 0;
      for (var i = 0; i < hosts.length; i++) {
        if (hosts[i].querySelector('button[data-variant-id="' + variantId + '"]')) { hit = hosts[i]; hitCount++; }
      }
      if (hitCount === 1) return hit.getAttribute('data-silqa-key');
    }
    return key;
  }
  function silqaAnnounce() {
    try {
      var s = document.getElementById('CartDrawer-LineItemStatus');
      if (s) s.setAttribute('aria-hidden', 'true');
      var cs = document.getElementById('CartDrawer-LiveRegionText');
      if (cs) { cs.setAttribute('aria-hidden', 'false'); setTimeout(function () { cs.setAttribute('aria-hidden', 'true'); }, 1000); }
    } catch (e) {}
  }
  /*
    SILQA 2026-08-22 レビュー指摘による修正（失敗の一言が消える問題）:
      旧: put() したあと 2600ms 後に1回だけ put し直すだけだった。
          ドロワーは失敗の直後に何度も描き直される（行の復元・静かな取り直し・
          サーバー応答の反映）。そのたびに文言が消え、再表示は1回きりなので、
          描き直しがその1回より後に来ると【何も出ないまま終わる】。
      新: 出したい文言を silqaPendingFail に覚えておき、描き直しのたびに書き戻す。
          6秒たったら覚えるのをやめる。表示先(#CartDrawer-CartErrors)が
          その時点で無くても、次の描き直しで必ず出る。
  */
  var silqaPendingFail = '';
  var failClearTimer = null;
  function silqaPaintFailNote() {
    if (!silqaPendingFail) return;
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el && el.textContent !== silqaPendingFail) el.textContent = silqaPendingFail;
  }
  // SILQA 2026-08-24: 文言を差し替えられるよう共通化した。
  //   再描画されても silqaPaintFailNote() が書き戻すので、どの文言でも消えない。
  function silqaShowNote(msg, ms) {
    silqaPendingFail = msg;
    silqaPaintFailNote();
    clearTimeout(failClearTimer);
    failClearTimer = setTimeout(function () {
      silqaPendingFail = '';
      var el = document.getElementById('CartDrawer-CartErrors');
      if (el) el.textContent = '';
    }, ms || 6000);
  }
  function silqaChangeFailNote() {
    silqaShowNote('通信エラーで反映できませんでした。時間をおいてもう一度お試しください。', 6000);
  }
  /*
    SILQA 2026-07-31 レビュー指摘による再設計（誤削除ブロッカーの根絶）:
    ・成功(200)＝そのkeyに正しく適用された。成功後の「見た目での空振り検知→再削除」は
      同一商品2行のときにもう片方まで消す事故になるため廃止。
    ・keyの世代ズレは実測で必ず 400「パラメータが無効です」になる。400/422を受けたときだけ、
      実カート(/cart.js)を照会し、同じ商品の行が「1行だけ」の場合に限り最新keyで1回やり直す。
      2行以上=曖昧なら何もせず、画面を実カートに描き直すだけ（勝手に選ばない）。
  */
  // SILQA 2026-08-22 河瀬さん報告の不具合修正「削除しようとすると通信エラー」:
  //   再送(retried=true)のときまで silqaCurrentKey() を通していたため、
  //   400を受けて /cart.js から引き直した最新keyが、送信直前に画面基準の古いkeyへ
  //   戻されて、2回目も400になり「通信エラー」が出ていた。
  //   再送のときは引き直さず、渡されたkeyをそのまま使う。
  function silqaDoChange(key, quantity, variantId, retried) {
    var useKey = retried ? key : silqaCurrentKey(key, variantId);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: useKey, quantity: quantity, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) {
        // SILQA 2026-08-24 河瀬さん報告の不具合修正
        //   「在庫上限の商品でドロワーの＋を押すと【通信エラー】と出て、しかも同じ要求を再送する」
        //   Shopify公式(Cart AJAX API)では、422 は「要求数量が在庫を超えた」を意味する。
        //   https://shopify.dev/docs/api/ajax/reference/cart
        //   keyの世代ズレ(400)とは原因が別で、同じ数量を送り直しても必ずまた422になる。
        //   そこで422は分けて扱い、Shopifyが返す説明文をそのまま出し、再送しない。
        if (r.status === 422) {
          return r.json().catch(function () { return null; }).then(function (body) {
            // Shopifyの説明文は「カートへ追加した」場面向けの言い回しなので、
            // ドロワーの＋（数量変更）で出すと「追加されました」と読めてしまう。
            // その言い回しのときだけ、この場面に合う文言へ置き換える。
            var 説明 = (body && body.description) ? String(body.description) : '';
            var 文 = (!説明 || 説明.indexOf('追加されました') >= 0)
                   ? 'ご用意できる在庫の上限のため、これ以上は増やせません。'
                   : 説明;
            scheduleQuietRepair();
            silqaShowNote(文, 8000);
            return false;
          });
        }
        if (!retried && r.status === 400 && variantId) {
          return fetch('/cart.js').then(function (cr) { return cr.json(); }).then(function (cart) {
            var hits = [];
            for (var i = 0; i < cart.items.length; i++) {
              if (String(cart.items[i].variant_id) === String(variantId)) hits.push(cart.items[i]);
            }
            if (hits.length === 1) return silqaDoChange(hits[0].key, quantity, variantId, true);
            scheduleQuietRepair();
            return false;
          });
        }
        throw new Error('HTTP ' + r.status);
      }
      return r.json().then(function (d) {
        if (!renderDrawer(d)) scheduleQuietRepair();
        silqaAnnounce();
        return true;
      });
    }).catch(function () {
      // 失敗（429等）: 部品を取り直して実カートに合わせ、利用者にも一言表示する
      scheduleQuietRepair();
      silqaChangeFailNote();
      return false;
    });
  }
  function silqaCartChange(key, quantity, rowEl, variantId) {
    if (!key) return;
    if (changeBusy[key]) {
      // 処理中の連打は「最後の値」だけ控えて、処理が終わったら自動で適用する
      changePending[key] = quantity;
      return;
    }
    changeBusy[key] = true;
    // SILQA 2026-07-31 体感の即時化: 削除はタップした瞬間に行を消す（最後の1行なら即・空カート表示）。
    // サーバーの正解が届いたら本描画が上書きし、万一失敗したら行を戻して一言表示する。
    // SILQA 2026-08-22 河瀬さん報告の不具合修正「削除に失敗しても行が戻らない」:
    //   最後の1行を消すと applyEmptyTemplate() がドロワーの中身を丸ごと差し替えるため、
    //   rowEl が DOM から外れて isConnected=false になり、失敗しても行を戻せなかった。
    //   （実カートには商品が残っているのに「カートは空です」のまま）
    //   失敗したときに元へ戻せるよう、差し替える前の中身を控えておく。
    var 戻す = null;
    if (rowEl) {
      if (quantity === 0) {
        // 控えは「行を隠す前」に取る。隠した後だと display:none が焼き込まれ、
        // 失敗して戻したときに行が見えないままになる（2026-08-22 レビュー指摘）。
        var 可視 = Array.prototype.filter.call(document.querySelectorAll('#CartDrawer .cart-item'), function (r) { return r.style.display !== 'none'; });
        var 最後の1行 = 可視.length <= 1;
        if (最後の1行) {
          var innerEl = document.querySelector('#CartDrawer .drawer__inner');
          var cdEl = document.querySelector('cart-drawer');
          if (innerEl) {
            戻す = { el: innerEl, html: innerEl.innerHTML, empty: cdEl ? cdEl.classList.contains('is-empty') : false };
          }
        }
        rowEl.style.display = 'none';
        if (最後の1行) applyEmptyTemplate();
      } else {
        rowEl.style.opacity = '.5'; rowEl.style.pointerEvents = 'none';
      }
    }
    // 変更は1件ずつ順番に実行する（並行実行だと古い応答が後から届いて表示が巻き戻るため）
    changeChain = changeChain.then(function () {
      return silqaDoChange(key, quantity, variantId, false);
    }).then(function (ok) {
      delete changeBusy[key];
      // 失敗したのに空カート表示へ差し替えていたら、消す前の中身に戻す。
      // そのあとの失敗メッセージ表示先(#CartDrawer-CartErrors)もこれで生き返る。
      if (ok === false && 戻す && 戻す.el && 戻す.el.isConnected) {
        戻す.el.innerHTML = 戻す.html;
        var cd2 = document.querySelector('cart-drawer');
        if (cd2 && !戻す.empty) cd2.classList.remove('is-empty');
        戻す = null;
        silqaPaintFailNote();   // 戻した直後に一言を書き戻す（2026-08-22）
      }
      // 成功したら、もう出す必要は無い
      if (ok !== false) { silqaPendingFail = ''; clearTimeout(failClearTimer); }
      if (rowEl && rowEl.isConnected) {
        if (ok === false) rowEl.style.display = '';
        rowEl.style.opacity = ''; rowEl.style.pointerEvents = '';
      }
      if (Object.prototype.hasOwnProperty.call(changePending, key)) {
        var nv = changePending[key];
        delete changePending[key];
        // 失敗していたら同じ値でも再実行する（利用者の意図した数量を黙って捨てない）
        if (ok === false || nv !== quantity) silqaCartChange(key, nv, silqaFindRow(key), variantId);
      }
    });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target && e.target.closest ? e.target.closest('#CartDrawer cart-remove-button[data-silqa-key]') : null;
    if (!rm) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var vBtn = rm.querySelector('button[data-variant-id]');
    silqaCartChange(rm.getAttribute('data-silqa-key'), 0, rm.closest('.cart-item'), vBtn ? vBtn.getAttribute('data-variant-id') : null);
  }, true);
  document.addEventListener('change', function (e) {
    var inp = e.target && e.target.matches && e.target.matches('#CartDrawer .quantity__input[data-silqa-key]') ? e.target : null;
    if (!inp) return;
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < 0) { v = parseInt(inp.getAttribute('value'), 10) || 1; inp.value = v; }
    silqaCartChange(inp.getAttribute('data-silqa-key'), v, inp.closest('.cart-item'), inp.getAttribute('data-quantity-variant-id'));
  }, true);

  /*
    SILQA 2026-07-30: 最終手段の再読込後にドロワーを自動で開き直す。
    （renderOrRecover が sessionStorage にフラグを立てて再読込した場合のみ動く）
  */
  function reopenIfFlagged() {
    try {
      if (!sessionStorage.getItem('silqaReopenDrawer')) return;
      sessionStorage.removeItem('silqaReopenDrawer');
      var cd = document.querySelector('cart-drawer');
      if (!cd) return;
      if (typeof cd.open === 'function') { cd.open(); }
      else { cd.classList.add('animate', 'active'); }
    } catch (e) {}
  }
  if (document.readyState !== 'loading') { reopenIfFlagged(); }
  else { document.addEventListener('DOMContentLoaded', reopenIfFlagged); }

  /*
    SILQA 2026-07-30 河瀬さん指示・不具合修正:
    「ドロワーで商品をすべて削除すると真っ白になり、カートが空です にならない」

    原因: ドロワー内の削除・数量変更はDawn標準の処理が担うが、Shopifyが部品(sections)を
    返さなかった場合（追加時と同じ現象の削除経路版）、Dawnは
      (1) 先に「空カート」の見た目クラスを適用してから
      (2) 中身のHTML差し替えで例外を起こして止まる
    ため、行もヘッダーも隠れた白い画面だけが残る。
    Dawnの差し替え関数(getSectionInnerHTML)を包み、部品が壊れていた場合は
      - 現在の表示を維持（例外で止めない）
      - 部品を取り直して静かに描画し直す
    ように補強する。カート追加側の多段復旧と対になる修正。
  */
  var repairScheduled = false;
  function scheduleQuietRepair() {
    if (repairScheduled) return;
    repairScheduled = true;
    var attempt = function (retryLeft) {
      fetchSections()
        .then(function (d) { renderDrawer(d, false); repairScheduled = false; })
        .catch(function () {
          // 429（回数制限）等で取り直しに失敗した場合は少し待ってもう一度だけ試す
          if (retryLeft > 0) { setTimeout(function () { attempt(retryLeft - 1); }, 3200); }
          else { repairScheduled = false; }
        });
    };
    setTimeout(function () { attempt(1); }, 300);
  }
  function makeSafe(C) {
    var proto = C && C.prototype;
    // 継承チェーンをさかのぼり、getSectionInnerHTML を実際に持つ場所を包む
    while (proto && !Object.prototype.hasOwnProperty.call(proto, 'getSectionInnerHTML')) {
      proto = Object.getPrototypeOf(proto);
    }
    if (!proto || proto.__silqaSafe) return;
    proto.__silqaSafe = true;
    var orig = proto.getSectionInnerHTML;
    proto.getSectionInnerHTML = function (html, selector) {
      try {
        if (typeof html === 'string' && html !== '') {
          return orig.call(this, html, selector);
        }
      } catch (e) {}
      // 部品が欠けていた/壊れていた: 現状維持で例外を防ぎ、あとで静かに直す
      scheduleQuietRepair();
      var cur = document.querySelector(selector || '.shopify-section');
      return cur ? cur.innerHTML : '';
    };
  }
  if (window.customElements && customElements.whenDefined) {
    ['cart-drawer', 'cart-items', 'cart-drawer-items'].forEach(function (name) {
      customElements.whenDefined(name).then(function (C) { makeSafe(C); }).catch(function () {});
    });
  }

  /*
    SILQA 2026-07-30: Safariの「戻る」対策（bfcache）。
    iPhoneのSafariは戻る操作で古い画面をメモリからそのまま復元するため、
    別ページでカートを操作した後に戻ると、カートアイコンやドロワーが古いままになる。
    復元イベント(pageshow persisted)を捕まえ、部品を取り直して静かに最新化する。
  */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (document.querySelector('cart-items')) { window.location.reload(); return; }
    fetchSections().then(function (d) { renderDrawer(d, false); }).catch(function () {});
  });
})();
